import { getAccountPagePageStub } from './accountPaging';

const { accounts } = getAccountPagePageStub();
let favouriteAccountsList = accounts[0] || [];

export const setFavouriteAccounts = (newFavourites) => {
	favouriteAccountsList = newFavourites.accounts.map((newFavouriteAccount) =>
		accounts.find((account) => account.id === newFavouriteAccount.id)
	);
};

export const favouriteAccounts = () => ({
	accounts: [favouriteAccountsList],
	total_number_of_accounts: window.location.search.includes('lcv') ? 35 : 10,
});
